import { Link } from 'react-router-dom';
import header from '../assets/header.jpg';

function Footer({ currentLang }) {
  const content = {
    en: {
      rights: "All Rights Reserved",
      col1Title: "Educational Store",
      col1Item1: "Browse All Worksheets",
      col1Item2: "Bundles & Special Offers",
      col2Title: "Teacher Support",
      col2Item1: "Terms & Licensing Framework",
      col2Item2: "Contact Educator",
      col3Title: "Connect With Us",
      secureMessage: "Secure digital item delivery via verified educational portals.",
      termsLink: "Conditions of Use"
    },
    gr: {
      rights: "Με επιφύλαξη παντός δικαιώματος",
      col1Title: "Ψηφιακό Κατάστημα",
      col1Item1: "Όλα τα Φύλλα Εργασίας",
      col1Item2: "Πακέτα Υλικού & Προσφορές",
      col2Title: "Υποστήριξη",
      col2Item1: "Νομικό Πλαίσιο Αδειών",
      col2Item2: "Επικοινωνία",
      col3Title: "Σύνδεσμοι",
      secureMessage: "Ασφαλής ψηφιακή παράδοση αρχείων μέσω εκπαιδευτικών πλατφορμών.",
      termsLink: "Όροι Χρήσης"
    },
    it: {
      rights: "Tutti i diritti riservati",
      col1Title: "Negozio Didattico",
      col1Item1: "Sfoglia Tutte le Risorse",
      col1Item2: "Pacchetti e Offerte Speciali",
      col2Title: "Supporto Clienti",
      col2Item1: "Quadro Licenze e Termini",
      col2Item2: "Contatta l'Insegnante",
      col3Title: "Social Network",
      secureMessage: "Consegna digitale sicura dei file tramite portali educativi esterni.",
      termsLink: "Condizioni d'Uso"
    }
  };

  const t = content[currentLang];

  return (
    <div
      className="py-4 mt-auto" /* mt-auto neatly pushes the footer down if content is short */
      style={{
        position: 'relative', /* Changed from 'fixed' to clean document flow */
        width: '100%',
        backgroundImage: `url(${header})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        marginTop: '3rem', /* Clean, balanced spacing right above the footer */
        borderTop: 'none', 
        boxShadow: '0 -1px 0 0 rgba(44, 62, 53, 0.12), 0 -4px 20px rgba(0, 0, 0, 0.02)',
        zIndex: 10
      }}
    >
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(251, 250, 248, 0.98)', zIndex: 0 }}></div>

      <div className="footer-grid-container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="row g-3 text-start d-none d-md-flex">
          
          <div className="col-md-3">
            <div className="footer-heading mb-2">{t.col1Title}</div>
            <ul className="list-unstyled d-flex flex-column gap-1">
              <li>
                <a className="footer-marketplace-link" rel="noreferrer" href="https://eduki.com/gr/search-results?query=Pter%CE%BFessa" target="_blank">
                  {t.col1Item1}
                </a>
              </li>
              <li>
                <a className="footer-marketplace-link" rel="noreferrer" href="https://eduki.com/gr/search-results?query=Pter%CE%BFessa" target="_blank">
                  {t.col1Item2}
                </a>
              </li>
            </ul>
          </div>

          <div className="col-md-3">
            <div className="footer-heading mb-2">{t.col2Title}</div>
            <ul className="list-unstyled d-flex flex-column gap-1">
              <li>
                <Link className="footer-marketplace-link" to="/conditions-of-use">
                  {t.col2Item1}
                </Link>
              </li>
              <li>
                <a className="footer-marketplace-link" href="mailto:support@pteroessa.com">
                  {t.col2Item2}
                </a>
              </li>
            </ul>
          </div>

          <div className="col-md-2">
            <div className="footer-heading mb-2">{t.col3Title}</div>
            <ul className="list-unstyled d-flex flex-column gap-1">
              <li>
                <a className="footer-marketplace-link" rel="noreferrer" href="https://eduki.com/gr/search-results?query=Pter%CE%BFessa" target="_blank">
                  Eduki Store
                </a>
              </li>
              <li>
                <a className="footer-marketplace-link" rel="noreferrer" href="https://www.instagram.com/pteroessa/" target="_blank">
                  Instagram
                </a>
              </li>
            </ul>
          </div>

          <div className="col-md-4 text-md-end">
            <div className="footer-heading mb-2">Pterόessa Marketplace</div>
            <p className="small text-muted m-0" style={{ fontSize: '0.75rem', lineHeight: '1.4' }}>
              {t.secureMessage}
            </p>
          </div>
        </div>

        <div className="footer-legal-bar d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
          <div>
            &copy; 2026 <strong>Pterόessa Platform</strong>. {t.rights}.
          </div>
          <div className="d-flex gap-3 font-weight-bold" style={{ fontSize: '12px' }}>
            <Link to="/conditions-of-use" style={{ color: '#2c3e35', textDecoration: 'none', fontWeight: 600 }}>
              {t.termsLink}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;